"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import type { SeriesDetail } from "@/types/series";
import Modal from "@/components/portal/Modal";
import SeriesHeroSection from "./SeriesHeroSection";
import SeriesMobileMeta from "./SeriesMobileMeta";
import SeriesBelowFold from "./SeriesBelowFold";
import { useSeriesDerived } from "./useSeriesDerived";
import { useContentAccess } from "../_shared/useContentAccess";
import { useSeriesSeasons } from "@/queries/series";
import { useUserStore } from "@/stores/useAuthStore";
const TicketModal = dynamic(() => import("./TicketModal"), {
  ssr: false
});
interface Props {
  id: string;
  serverData: SeriesDetail;
}
export default function SeriesIdPage(t0) {
  const $ = _c(64);
  const {
    serverData
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    isLoggedIn
  } = useUserStore();
  const router = useRouter();
  let t1;
  if ($[0] !== serverData) {
    t1 = serverData ?? {} as SeriesDetail;
    $[0] = serverData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const series = t1;
  console.log("series", series);
  const {
    year,
    countries,
    genres,
    subtitles,
    images,
    persons,
    cast,
    directorName,
    durationLabel
  } = useSeriesDerived(series);
  const {
    userProfile,
    hasActiveSubscription,
    hasActiveTicket
  } = useContentAccess(series?.uuid);
  const {
    data: seasonsData,
    isLoading: isSeasonsLoading
  } = useSeriesSeasons(series?.unique_code);
  let t2;
  if ($[2] !== seasonsData?.data?.seasons) {
    const seasons = seasonsData?.data?.seasons ?? [];
    t2 = seasons.flatMap(_temp).filter(_temp2).at(-1)?.uuid ?? "";
    $[2] = seasonsData?.data?.seasons;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const lastEpisodeUuid = t2;
  let t3;
  if ($[4] !== isLoggedIn || $[5] !== router) {
    t3 = () => isLoggedIn ? setIsModalOpen(true) : router.push("/login");
    $[4] = isLoggedIn;
    $[5] = router;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== countries || $[8] !== durationLabel || $[9] !== genres || $[10] !== hasActiveSubscription || $[11] !== hasActiveTicket || $[12] !== images || $[13] !== isSeasonsLoading || $[14] !== lastEpisodeUuid || $[15] !== persons || $[16] !== series || $[17] !== subtitles || $[18] !== t3 || $[19] !== year) {
    t4 = <SeriesHeroSection series={series} images={images} year={year} countries={countries} genres={genres} subtitles={subtitles} persons={persons} durationLabel={durationLabel} lastEpisodeUuid={lastEpisodeUuid} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} episodesLoading={isSeasonsLoading} onBuyClick={t3} />;
    $[7] = countries;
    $[8] = durationLabel;
    $[9] = genres;
    $[10] = hasActiveSubscription;
    $[11] = hasActiveTicket;
    $[12] = images;
    $[13] = isSeasonsLoading;
    $[14] = lastEpisodeUuid;
    $[15] = persons;
    $[16] = series;
    $[17] = subtitles;
    $[18] = t3;
    $[19] = year;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== isLoggedIn || $[22] !== router) {
    t5 = () => isLoggedIn ? setIsModalOpen(true) : router.push("/login");
    $[21] = isLoggedIn;
    $[22] = router;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== countries || $[25] !== durationLabel || $[26] !== genres || $[27] !== hasActiveSubscription || $[28] !== hasActiveTicket || $[29] !== images || $[30] !== isSeasonsLoading || $[31] !== lastEpisodeUuid || $[32] !== series || $[33] !== subtitles || $[34] !== t5 || $[35] !== year) {
    t6 = <SeriesMobileMeta series={series} images={images} year={year} countries={countries} genres={genres} subtitles={subtitles} durationLabel={durationLabel} lastEpisodeUuid={lastEpisodeUuid} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} episodesLoading={isSeasonsLoading} onBuyClick={t5} />;
    $[24] = countries;
    $[25] = durationLabel;
    $[26] = genres;
    $[27] = hasActiveSubscription;
    $[28] = hasActiveTicket;
    $[29] = images;
    $[30] = isSeasonsLoading;
    $[31] = lastEpisodeUuid;
    $[32] = series;
    $[33] = subtitles;
    $[34] = t5;
    $[35] = year;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  const t7 = series?.uuid ?? "";
  const t8 = series?.unique_code ?? "";
  const t9 = series?.title_fa || "";
  const t10 = series?.summary || "";
  const t11 = userProfile?.uuid || "";
  const t12 = series?.content_access ?? undefined;
  let t13;
  if ($[37] !== cast || $[38] !== hasActiveSubscription || $[39] !== hasActiveTicket || $[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t13 = <SeriesBelowFold seriesUuid={t7} uniqueCode={t8} title={t9} summary={t10} cast={cast} profileUuid={t11} status={t12} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} />;
    $[37] = cast;
    $[38] = hasActiveSubscription;
    $[39] = hasActiveTicket;
    $[40] = t10;
    $[41] = t11;
    $[42] = t12;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  let t14;
  if ($[47] !== t13 || $[48] !== t6) {
    t14 = <div className="mx-auto container max-w-3xl px-4 sm:px-6 lg:px-12 pb-12 lg:-translate-y-5 xl:-translate-y-10 2xl:-translate-y-21.25">{t6}{t13}</div>;
    $[47] = t13;
    $[48] = t6;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsModalOpen(false);
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setIsModalOpen(false);
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  const t17 = series?.ticket?.uuid ?? "";
  const t18 = series?.title_fa ?? "";
  const t19 = images.desktop || images.tablet || images.mobile || "";
  let t20;
  if ($[52] !== directorName || $[53] !== t17 || $[54] !== t18 || $[55] !== t19) {
    t20 = <TicketModal onClose={t16} seriesUuid={t17} seriesTitle={t18} seriesPoster={t19} seriesDirector={directorName} />;
    $[52] = directorName;
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== isModalOpen || $[58] !== t20) {
    t21 = <Modal open={isModalOpen} onClose={t15}>{t20}</Modal>;
    $[57] = isModalOpen;
    $[58] = t20;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== t14 || $[61] !== t21 || $[62] !== t4) {
    t22 = <div className="w-full flex flex-col MovieBoxe">{t4}{t14}{t21}</div>;
    $[60] = t14;
    $[61] = t21;
    $[62] = t4;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  return t22;
}
function _temp2(ep) {
  return ep.video_file_id;
}
function _temp(s) {
  return s.episodes ?? [];
}